












































import Vue from 'vue';

import { SampleObject } from './config';

interface IComputed {
  stringifiedSampleSize: string;
  stringifiedPerplexity: string;
  stringifiedIterations: string;
}

interface IMethods {
  handleClick: () => void;
}

interface IProps {
  sample: SampleObject;
  active: number;
  index: number;
}

export default Vue.extend<Record<string, unknown>, IMethods, IComputed, IProps>({
  name: 'Sample',

  props: {
    sample: {
      type: Object,
      required: true,
    },

    active: {
      type: Number,
      default: -1,
    },

    index: {
      type: Number,
      required: true,
    },
  },

  computed: {
    stringifiedSampleSize() {
      return `${this.sample.sampleSize}`.replace(/(\d)(?=(\d\d\d)+$)/, '$1,');
    },
    stringifiedPerplexity() {
      return `${this.sample.perplexity}`.replace(/(\d)(?=(\d\d\d)+$)/, '$1,');
    },
    stringifiedIterations() {
      return `${this.sample.iterations}`.replace(/(\d)(?=(\d\d\d)+$)/, '$1,');
    },
  },

  methods: {
    handleClick() {
      this.$emit('click', this.index);
    },
  },
});
